import { Search } from '@/DTOS/PmContractAdditionalAct/Search';
import request from '../../utils/request';

const PmContractAdditionalActService = {
  search: (search: Search) => {
    return request('/pmContractAdditionalAct/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (/** @type {any} */ file: any) => {
    return request(
      '/pmContractAdditionalAct/upsert',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  searchComment: (search: Search) => {
    return request('/pmContractAdditionalAct/searchComment', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
};

export default PmContractAdditionalActService;
